import React, { useCallback } from 'react';
import { observer } from 'mobx-react';
import { Icon, StackLayout, Text } from '@wemogy/reactbase';
var AzureStorageEntry = function (_a) {
    var entry = _a.entry, azureStorageContainerTheme = _a.azureStorageContainerTheme, marginBottom = _a.marginBottom, containerStore = _a.containerStore, onBlobSelected = _a.onBlobSelected;
    var handlePress = useCallback(function () {
        if (entry.isBlob) {
            onBlobSelected(entry);
        }
        else {
            containerStore.setActivePrefix(entry.prefix);
        }
    }, [entry, onBlobSelected]);
    return (React.createElement(StackLayout, { horizontal: true, vCenter: true, padding: 0.5, border: 0.125, marginBottom: marginBottom, onPress: handlePress },
        React.createElement(Icon, { variationKey: azureStorageContainerTheme.iconVariation, icon: entry.isBlob ? azureStorageContainerTheme.fileIcon : azureStorageContainerTheme.virtualDirectoryIcon, marginRight: true }),
        React.createElement(Text, { stretch: true, variationKey: azureStorageContainerTheme.textVariation }, entry.name),
        React.createElement(Icon, { variationKey: azureStorageContainerTheme.iconVariation, icon: entry.isBlob ? azureStorageContainerTheme.showFileIcon : azureStorageContainerTheme.showVirtualDirectoryIcon, marginRight: true })));
};
export default observer(AzureStorageEntry);
//# sourceMappingURL=AzureStorageEntry.js.map